import React from "react";

import { getListingBrandVariant } from "../helpers/listingBrandConfig";

const ListingBrandDot = ({ brandName }) => {
  const variant = getListingBrandVariant(brandName);

  return (
    <span
      className={`rc-lcard__brand-dot rc-lcard__brand-dot--${variant}`}
      title={brandName || undefined}
      aria-hidden="true"
    />
  );
};

export default ListingBrandDot;
